import { render, staticRenderFns } from "./resultsDetails.vue?vue&type=template&id=54f3d4f8&scoped=true"
import script from "./resultsDetails.vue?vue&type=script&lang=js"
export * from "./resultsDetails.vue?vue&type=script&lang=js"
import style0 from "./resultsDetails.vue?vue&type=style&index=0&id=54f3d4f8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f3d4f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54f3d4f8')) {
      api.createRecord('54f3d4f8', component.options)
    } else {
      api.reload('54f3d4f8', component.options)
    }
    module.hot.accept("./resultsDetails.vue?vue&type=template&id=54f3d4f8&scoped=true", function () {
      api.rerender('54f3d4f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GuoJiao/resultsAnalysis/resultsDetails.vue"
export default component.exports